import {
  UserOutlined,
  ScheduleOutlined,
  CarryOutOutlined,
  SmileOutlined,
  InfoCircleOutlined,
  BookOutlined,
  TrophyOutlined,
  UsergroupAddOutlined,
  ReadOutlined,
  ContainerOutlined,
  LineChartOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useWindowSize } from "@react-hook/window-size";
import { useDispatch } from "react-redux";
import ProfileElevi from "../Pages/Admin/ProfileElevi";
import { Breadcrumb, Layout, Menu, theme, Image } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import Chats from "../Pages/Chats/View";
import { getDataDoc } from "../database";
import { testSlice } from "../redux/store";
import MobileBottomNavigation from "./MobileBottomNavigation";
import "./MobileNavigation.css";
const { actions } = testSlice;
const { GET_USER, SESSION } = actions;
const { Header, Content, Footer, Sider } = Layout;
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const NavbarElev = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const user = useSelector((state) => state.user);
  const [width, height] = useWindowSize();
  const [open, setOpen] = useState(false);
  const [addElev, setAddElev] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = width <= 768;
  const items = [
    user.mode === "hybrid" && getItem("Mod părinte", "parent"),
    getItem("Clase", "clase", <ReadOutlined />),
    getItem("Orar", "orar", <ScheduleOutlined />),
    getItem("Elevi", "profile-elevi", <UsergroupAddOutlined />, [
      { label: "Cauta elev", key: "search-elev" },
    ]),
    getItem("Condica", "condica", <BookOutlined />),
    getItem("Feedback", "feedback", <TrophyOutlined />),
    getItem("Statistici", "statistici-clase", <LineChartOutlined />),
    getItem("Ajutor", "ajutor", <InfoCircleOutlined />),
    getItem("Profil", "profil", <SmileOutlined />),
  ];


  if (isMobile) {
    return (
      <>
        <div className={`mobile-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={() => setMobileMenuOpen(false)} />
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <img
              src={process.env.REACT_APP_LOGO}
              alt="Logo"
              className="mobile-menu-logo"
              onClick={() => navigate("/")}
            />
            <div className="mobile-menu-close" onClick={() => setMobileMenuOpen(false)}>×</div>
          </div>
          <Menu
            onClick={async (e) => {
              setMobileMenuOpen(false);
              if (e.key === "parent") {
                let u = await getDataDoc("users", user.id || user.uid);
                let e = u?.copii[0].idElev;

                let data = await getDataDoc("elevi", e);
                if (!data) return;

                let dataUser = { ...user, ...data };

                data = await getDataDoc("claseData", dataUser?.clasa);
                dispatch(
                  GET_USER({
                    ...dataUser,
                    clasaMea: data,
                    type: "elevi",
                    mainType: "parinte",
                    altiCopii: u?.copii,
                    uid: e,
                    id: e,
                    oldUid: user.id || user.uid,
                  })
                );
                navigate("/");
                return;
              }
              if (e.key === "search-elev") {
                setOpenSearch(true);
                return;
              }
              if (e.key === "mesaje") setOpen(true);
              else navigate("/" + e.key);
            }}
            theme="light"
            mode="inline"
            items={items}
            className="mobile-menu-items"
          />
        </div>
        <MobileBottomNavigation userType="profesor" onMenuOpen={setMobileMenuOpen} />
        <Chats open={open} setOpen={setOpen} />
        <ProfileElevi open={openSearch} setOpen={setOpenSearch} />
      </>
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      breakpoint="lg"
      collapsedWidth={70}
    >
      <Chats open={open} setOpen={setOpen} />
      <ProfileElevi open={openSearch} setOpen={setOpenSearch} />
      <div
        style={{ width: "200px", display: "flex", justifyContent: "center" }}
      >
        {" "}
        {collapsed === false && (
          <Image
            width={100}
            height={100}
            src={process.env.REACT_APP_LOGO}
            preview={false}
            onClick={() => {
              navigate("/");
            }}
          />
        )}
      </div>

      <Menu
        onClick={async (e) => {
          if (e.key === "parent") {
            let u = await getDataDoc("users", user.id || user.uid);
            let e = u?.copii[0].idElev;

            let data = await getDataDoc("elevi", e);
            if (!data) return;

            let dataUser = { ...user, ...data };

            data = await getDataDoc("claseData", dataUser?.clasa);
            dispatch(
              GET_USER({
                ...dataUser,
                clasaMea: data,
                type: "elevi",
                mainType: "parinte",
                altiCopii: u?.copii,
                uid: e,
                id: e,
                oldUid: user.id || user.uid,
              })
            );
            navigate("/");
            return;
          }
          if (e.key === "search-elev") {
            setOpenSearch(true);
            return;
          }
          if (e.key === "mesaje") setOpen(true);
          else navigate("/" + e.key);
        }}
        theme="dark"
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={items}
      />
    </Sider>
  );
};
export default NavbarElev;
